var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.218 3.748-.025.005a4.87 4.87 0 0 0-3.099 2.22L5.205 7.882a2 2 0 0 0-.802 2.6l.07.133 2.914 5.059v.577c0 1.574.748 2.973 1.907 3.861A3.988 3.988 0 0 1 7 18.286l-3.875-6.712A4 4 0 0 1 4.589 6.11l3.464-2a3.989 3.989 0 0 1 3.165-.362z",
    fill: "#8F9BB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.863 8.264v8.264A3.138 3.138 0 0 0 12 19.665h4.446a3.138 3.138 0 0 0 3.137-3.137V8.264a3.138 3.138 0 0 0-3.137-3.137H12a3.138 3.138 0 0 0-3.137 3.137zm7.387-4.626A4.862 4.862 0 0 1 21.113 8.5v7.75a4.862 4.862 0 0 1-4.863 4.863h-4a4.862 4.862 0 0 1-4.862-4.863V8.5a4.862 4.862 0 0 1 4.862-4.862h4z",
    fill: "#8F9BB3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8.975a.75.75 0 1 1 0-1.5h3a.75.75 0 1 1 0 1.5h-3z",
    fill: "#8F9BB3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#8F9BB3",
    strokeWidth: 1.5,
    x: 12,
    y: 11.6,
    width: 4.5,
    height: 4.5,
    rx: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon-camera.acc42db5.svg";
export { ForwardRef as ReactComponent };